module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAM1BMVEUAAACqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqoNNXyEAAAAEHRSTlMAyg3z8eCOcWZVMwOamSAfkGmo4gAAAERJREFUGNNjwAO4ORmRuUzsrAICCC4/G4uAAERAAAqYebiQBRg5mIBMqAAYQ5hARJYAwlA0a3m5kB3GB3EYptMxPYcJABE7BcE8ndUJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_notice.png
// module id = T8h7
// module chunks = 9